<div class="w-full text-xs" data-test="formula-examples-table">
  @for (row of safeRows(); track $index) {
    @if (row.layout === 'wide') {
      <!-- Wide layout: two columns — expression | stacked code + preview -->
      <div
        class="grid md:grid-cols-[1.5fr_3fr] gap-4 items-start py-3 px-1 border-b border-gray-100 last:border-0"
        data-test="formula-examples-table-row"
      >
        <span class="text-gray-600 leading-relaxed" [innerHTML]="row.safeExpression"></span>
        <div class="flex flex-col gap-2">
          <code class="font-mono text-blue-600 bg-blue-50 px-1.5 py-1 rounded whitespace-pre-wrap break-all">{{ row.exampleText }}</code>
          <span [innerHTML]="row.safePreviewHTML"></span>
        </div>
      </div>
    } @else {
      <!-- Normal layout: four columns — expression | example | preview | result -->
      <div
        class="grid md:grid-cols-[1.5fr_1.5fr_2fr_0.7fr] gap-3 items-center py-2 px-1 border-b border-gray-100 last:border-0"
        data-test="formula-examples-table-row"
      >
        <span class="text-gray-600 leading-relaxed" [innerHTML]="row.safeExpression"></span>
        <code class="font-mono text-blue-600 bg-blue-50 px-1.5 py-0.5 rounded self-start whitespace-nowrap">{{ row.exampleText }}</code>
        <span [innerHTML]="row.safePreviewHTML"></span>
        <span class="font-mono text-green-700 text-right">{{ row.result }}</span>
      </div>
    }
  }
</div>

